import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

const MainPage = () => {

  const quickNavIcons = useMemo(
    () => [
      {
        label: 'Calendar',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 3v2m8-2v2M7 8h10M5 12h14m-1 9H6a2 2 0 01-2-2V7a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" />
          </svg>
        ),
      },
      {
        label: 'Messages',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h8m-8 4h4m-7 6v-3.586a1 1 0 00-.293-.707L3 12V5a2 2 0 012-2h14a2 2 0 012 2v7l-1.414 1.707a1 1 0 00-.293.707V20l-4-4H7a2 2 0 00-2 2z" />
          </svg>
        ),
      },
      {
        label: 'Notifications',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1" />
          </svg>
        ),
      },
      {
        label: 'Bookmark',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 4a2 2 0 012-2h8a2 2 0 012 2v18l-6-3-6 3V4z" />
          </svg>
        ),
      },
      {
        label: 'Facility',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 21h18M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16M9 9h6" />
          </svg>
        ),
      },
    ],
    []
  );
  return (
    <main className="flex-1 bg-slate-50 h-screen overflow-y-auto">
      <header className="h-16 border-b border-gray-200 bg-gray-100 px-8 flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-800">Patient registration</h1>

        <div className="flex items-center gap-4 text-gray-500">
          {quickNavIcons.map((item, idx) => (
            <span
              key={`${item.label}-${idx}`}
              className="w-9 h-9 rounded-full bg-white shadow-sm flex items-center justify-center"
            >
              {item.icon}
            </span>
          ))}

          <div className="flex items-center gap-2 text-sm font-medium text-gray-600">
            <span>Main - FACILITY</span>
            <div className="w-9 h-9 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-semibold">
              MJ
            </div>
          </div>
        </div>
      </header>


     

      <div className="bg-white shadow-md min-h-[calc(100vh-3rem)]">
        <Outlet />
      </div>
    </main>
  );
};

export default MainPage;